import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Menu, X, Phone } from 'lucide-react'

const navLinks = [
  { name: 'Home', href: '#hero' },
  { name: 'Promotions', href: '#promotions' },
  { name: 'Services', href: '#services' },
  { name: 'Book Now', href: '#booking' },
  { name: 'Reviews', href: '#testimonials' },
  { name: 'Contact', href: '#contact' },
]

export default function Navbar({ scrollY }) {
  const [isOpen, setIsOpen] = useState(false)
  const isScrolled = scrollY > 50

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/90 backdrop-blur-md shadow-sm py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="#hero" className="flex items-center gap-2">
            <img
              src="/logo-transparent.png"
              alt="Emeralds Cuts"
              className={`object-contain transition-all ${isScrolled ? 'h-10' : 'h-12'}`}
            />
          </a>

          {/* Desktop Nav - Centered */}
          <nav className="hidden lg:flex items-center justify-center gap-1 absolute left-1/2 -translate-x-1/2">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isScrolled
                    ? 'text-gray-700 hover:text-[#2d7d32]'
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {link.name}
              </a>
            ))}
          </nav>

          {/* CTA */}
          <div className="hidden lg:flex items-center gap-4">
            <a href="tel:+19042930005" className={`text-sm font-medium ${isScrolled ? 'text-[#2d7d32]' : 'text-white'}`}>
              <Phone className="w-4 h-4 inline mr-1" />
              (904) 293-0005
            </a>
            <a
              href="#booking"
              className="px-5 py-2 bg-[#2d7d32] text-white rounded-full text-sm font-semibold hover:bg-[#1b5e20] transition-colors"
            >
              Get a Quote
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-gray-600"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-white border-t"
          >
            <div className="px-4 py-4 space-y-2">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="block px-4 py-3 rounded-lg text-gray-700 hover:bg-[#2d7d32]/10 font-medium text-center"
                  onClick={() => setIsOpen(false)}
                >
                  {link.name}
                </a>
              ))}
              <a
                href="#booking"
                className="block w-full text-center px-6 py-3 bg-[#2d7d32] text-white rounded-full font-semibold mt-4"
                onClick={() => setIsOpen(false)}
              >
                Get a Free Quote
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  )
}
